import { Input as InputA } from 'antd';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

type P = ComponentProps<typeof InputA>;

const Input = ({ placeholder, ...rest }: P) => {
  const { t } = useTranslation();

  return <InputA placeholder={typeof placeholder === 'string' ? t(placeholder) : placeholder} size="large" {...rest} />;
};

export default Input;
